export const getInitials = (name: string) => {
  const regexChar = /\D\w+/;

  return name
    .trim()
    .split(" ")
    .filter((word) => word.length > 0)
    .filter((word) => regexChar.test(word))
    .map((word) => word.substring(0, 1).toUpperCase())
    .join("");
};
